var _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ce153f",
    stroke: "#282d31",
    strokeWidth: 0,
    x: 25,
    y: 25,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "0.5s",
    from: "0 50 50",
    to: "180 50 50",
    type: "rotate",
    id: "strokeBox",
    attributeType: "XML",
    begin: "rectBox.end"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    fill: "#fff",
    width: 46,
    height: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.3s",
    attributeType: "XML",
    from: 50,
    to: 0,
    id: "rectBox",
    fill: "freeze",
    begin: "0s;strokeBox.end"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.617793457c50dd8644d9ce8c4f909e8a.svg";
export { ForwardRef as ReactComponent };